const footerNav = [
  { href: "#profile", label: "快速档案" },
  { href: "#updates", label: "近况动态" },
  { href: "#topics", label: "热议话题" },
  { href: "#details", label: "资料详情" },
  { href: "#social", label: "社交动态" },
  { href: "#faq", label: "常见问答" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/3">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-secondary-950 text-lg">
                <i className="ri-vip-diamond-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">松下纱荣子</span>
            </div>
            <p className="text-secondary-100/80 text-sm leading-relaxed max-w-md">
              一个把近况、八卦、个人资料、年龄、绯闻与 ins 动态集中在同一页的资讯入口，帮助你在一个页面内完成浏览与判断。
            </p>
          </div>

          <div className="lg:flex-1">
            <h2 className="font-label text-xs text-secondary-200/70 tracking-[0.2em] mb-4">
              页面分区
            </h2>
            <nav className="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-6">
              {footerNav.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  className="text-sm text-secondary-100/90 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {n.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-secondary-200/70 text-xs">
            本站内容为公开信息与网络讨论整理，仅供参考，不构成任何事实承诺。
          </p>
          <p className="text-secondary-200/70 text-xs">最近整理于 2026 年 10 月</p>
        </div>
      </div>
    </footer>
  );
}